function getTg() {
  if (typeof window === 'undefined') return undefined;
  return window.Telegram?.WebApp;
}

/**
 * Promise-based CloudStorage with JSON serialization.
 * Graceful no-op when Telegram is unavailable.
 */
export const cloud = {
  async get<T = unknown>(key: string): Promise<T | null> {
    const tg = getTg();
    if (!tg?.CloudStorage) return null;

    return new Promise((resolve) => {
      tg.CloudStorage!.getItem(key, (err: unknown, value?: string) => {
        if (err || value == null || value === '') {
          resolve(null);
          return;
        }
        try {
          resolve(JSON.parse(value) as T);
        } catch {
          resolve(null);
        }
      });
    });
  },

  async set(key: string, value: unknown): Promise<boolean> {
    const tg = getTg();
    if (!tg?.CloudStorage) return false;

    return new Promise((resolve) => {
      tg.CloudStorage!.setItem(key, JSON.stringify(value), (err: unknown) => {
        resolve(!err);
      });
    });
  },

  async remove(key: string): Promise<boolean> {
    const tg = getTg();
    if (!tg?.CloudStorage) return false;

    return new Promise((resolve) => {
      tg.CloudStorage!.removeItem(key, (err: unknown) => {
        resolve(!err);
      });
    });
  },

  async getKeys(): Promise<string[]> {
    const tg = getTg();
    if (!tg?.CloudStorage) return [];

    return new Promise((resolve) => {
      tg.CloudStorage!.getKeys((err: unknown, keys: string[]) => {
        resolve(err ? [] : keys ?? []);
      });
    });
  },
};
